import { Text, Alert } from 'braid-design-system';
import type { ReactNode } from 'react';

type SelectAdTypeErrorProps = {
  children: ReactNode;
  tone?: 'critical' | 'info';
};

export const SelectAdTypeError = ({
  children,
  tone = 'critical',
}: SelectAdTypeErrorProps) => (
  <Alert tone={tone}>
    <Text>{children}</Text>
  </Alert>
);
